export const ROUTES = {
  /* Navigation Routes */
  DASHBOARD_INDEX: '/dashboard',
  SURVEY_TEMPLATE_INDEX: '/surveys',
  BUSINESS_INDEX: '/business',
  QUESTION_INDEX: '/questions',
  REPORT_INDEX: '/reports',

  // Dashboard Routes
  BUSINESS_DASHBOARD_INDEX: '/businesses/:id/dashboard',

  /* Survey Routes */
  ADD_NEW_SURVEY_TEMPLATE: '/surveys/new',
  EDIT_SURVEY_TEMPLATE: '/surveys/:surveyTemplateId/edit',

  /* Survey Rewards */
  USER_SURVEY_REWARD: '/user_survey_rewards',

  /* Business routes */
  ADD_NEW_BUSINESS: '/businesses/new/basic-information',
  EDIT_BUSINESS_BASIC_INFO: '/businesses/:id/basic-information',
  BUSINESS_DETAIL: '/businesses/:id/basic-information',
  REQUEST_BUSINESS_ADD_ONS: '/businesses/:id/add-ons',
  BUSINESS_SURVEY_EMAIL_CONFIG: '/businesses/:id/email-config/survey',
  BUSINESS_COMMENT_EMAIL_CONFIG: '/businesses/:id/email-config/comment',
  BUSINESS_SMS_ALERT_CONFIG: '/businesses/:id/email-config/sms',
  BUSINESS_FILTER: '/surveys/:id/businesses',
  BUSINESS_CATEGORY_FILTER: '/category/:categoryId/businesses',
  BUSINESS_USER_DETAIL: '/businesses/:businessId/profile',
  BUSINESS_SURVEY_FEEDBACKS: '/businesses/:id/feedback_reports',
  BUSINESS_BILLING_ACTIVITY: '/businesses/:id/billing_activity',

  CUSTOM_SURVEY_LIST: '/businesses/:id/custom_surveys',
  CUSTOM_SURVEY_ADD: '/businesses/:id/custom_surveys/new',
  CUSTOM_SURVEY_EDIT: '/businesses/:id/custom_surveys/:customSurveyId/edit',
  CUSTOM_SURVEY_FEEDBACKS:
    '/businesses/:id/custom_surveys/:customSurveyId/feedback_reports',

  QUESTION_LIST: '/businesses/:id/surveys/all/questions',
  CUSTOM_QUESTION_LIST: '/businesses/:id/surveys/default/questions',
  CUSTOM_SURVEY_QUESTIONS:
    '/businesses/:id/custom_surveys/:customSurveyId/questions',

  REPORT_LIST: '/businesses/:id/reports/all',
  CUSTOM_REPORT_LIST: '/businesses/:id/reports/custom',
  CUSTOM_SURVEY_REPORTS:
    '/businesses/:id/custom_surveys/:customSurveyId/reports',
  PUBLIC_CUSTOM_SURVEY_REPORTS:
    '/businesses/:id/custom_surveys/:customSurveyId/surveyreports',

  USER_INDEX: '/users',
  USERS_LIST: '/businesses/:id/users',
  USER_EDIT: '/businesses/:id/users/:userId',
  USER_NEW: '/business/:id/users/new',
  USER_SHOW: '/users/:id',
  EMAIL_CONFIRMATION: '/users/confirmation',

  SOONO_SOCIAL: '/events',

  // Business User Invitation
  BUSINESS_USER_INVITATION_NEW: '/businesses/:id/user_invitations/new',
  // Validate User Invitation
  VALIDATE_BUSINESS_USER_INVITATION: '/user_invitations/:id',

  /* Question Route */
  CATEGORIES_QUESTIONS: '/surveys/:id/questions',

  /* Report Route */
  CATEGORY_REPORTS: '/reports/:id/reports',
  REWARD_ISSUED: '/businesses/:id/redemption/issued',
  REWARD_REDEEMED: '/businesses/:id/redemption/redeemed',

  // Reset Password
  PASSWORD_RESET: '/passwords/reset',
  NEW_PASSWORD: '/passwords/new',
  /* Measures of success Route */
  MEASURES_OF_SUCCESS: '/measures_of_success',

  ADDONS_REQUEST: '/addons/request',
  SIGNUP: '/signup',
  LOGIN: '/login',
  RENEW_SUBSCRIPTION: '/renew',

  TERMS_OF_USE: '/terms-of-use',
  PRIVACY_POLICY: '/privacy-policy',
};

export function insertIdtoUrl(url, id) {
  return url.replace(':id', id);
}

export function insertBusinessIdtoUrl(url, id) {
  return url.replace(':businessId', id);
}

export function insertCategoryIdtoUrl(url, id) {
  return url.replace(':categoryId', id);
}

export function insertCustomSurveyIdtoUrl(url, id, customSurveyId) {
  let updatedUrl = url;
  updatedUrl = insertIdtoUrl(updatedUrl, id);

  return updatedUrl.replace(':customSurveyId', customSurveyId);
}

export function insertUserIdtoUrl(url, id, userId) {
  let updatedUrl = url;
  updatedUrl = insertIdtoUrl(updatedUrl, id);

  return updatedUrl.replace(':userId', userId);
}

export const TRIAL_SIGNUP_ROUTES = {
  GETTING_STARTED: `${ROUTES.SIGNUP}`,
  CONTACT_DETAILS: `${ROUTES.SIGNUP}/contact-details`,
  SELECT_PLANS: `${ROUTES.SIGNUP}/select-plan`,
  BUSINESS_DETAILS: `${ROUTES.SIGNUP}/business-details`,
  TRIAL_PLANS: `${ROUTES.SIGNUP}/trial-plan`,
  PAYMENT_DETAILS: `${ROUTES.SIGNUP}/payment-details`,
  PAYMENT_ADDRESS: `${ROUTES.SIGNUP}/payment-address`,
};

export const RENEW_SUBSCRIPTION_ROUTES = {
  SELECT_PLANS: `${ROUTES.RENEW_SUBSCRIPTION}/select-plan`,
  PAYMENT_DETAILS: `${ROUTES.RENEW_SUBSCRIPTION}/payment-details`,
  PAYMENT_ADDRESS: `${ROUTES.RENEW_SUBSCRIPTION}/payment-address`,
};

export const ONBOARDING_ROUTES = {
  STEP_ONE: '/onboarding/one',
  STEP_TWO: '/onboarding/two',
  STEP_THREE: '/onboarding/three',
  STEP_FOUR: '/onboarding/four',
};

export const isOnboardingRoute = path => {
  for (let step in ONBOARDING_ROUTES) {
    if (ONBOARDING_ROUTES.hasOwnProperty(step)) {
      return ONBOARDING_ROUTES[step] == path;
    }
  }
};



// WEBPACK FOOTER //
// ./src/constants/Routes.js